import { Link } from 'react-router-dom'
import { useSesion } from '../auth/sesion'
import { Aviso } from '../componentes/ui'

/**
 * Se muestra a quien tiene sesión válida pero no el rol que la pantalla exige,
 * y a quien fue suspendido.
 *
 * Los tres casos se distinguen porque tienen tres salidas distintas: al
 * pendiente le falta que un admin le asigne rol, al suspendido le falta hablar
 * con un administrador, y a quien simplemente entró donde no le toca solo hay
 * que devolverlo a su sitio.
 */
export function SinAcceso() {
  const { yo, suspendida } = useSesion()
  const pendiente = yo?.rol === 'pendiente'

  return (
    <div className="max-w-[560px] mx-auto py-8">
      <div className="panel p-5">
        <h1 className="text-[17px] font-semibold text-acero-900">
          {suspendida
            ? 'Su cuenta está suspendida'
            : pendiente
              ? 'Su cuenta todavía no tiene acceso'
              : 'No tiene permiso para esta sección'}
        </h1>

        <div className="mt-3 space-y-3">
          {suspendida ? (
            <Aviso tono="error" titulo="Acceso desactivado">
              Un administrador de Compranorte desactivó esta cuenta. La sesión sigue siendo válida,
              pero no puede ver ni operar nada hasta que se reactive. Comuníquese con el equipo para
              saber el motivo.
            </Aviso>
          ) : pendiente ? (
            <Aviso tono="alerta" titulo="Falta asignarle un rol">
              Su cuenta está creada, pero un administrador de Compranorte debe indicar si usted es{' '}
              <strong>cliente</strong> o <strong>proveedor</strong> y asociarlo a su empresa. Hasta
              entonces puede navegar el catálogo, pero no comprar ni publicar.
            </Aviso>
          ) : (
            <Aviso tono="info">
              Esta sección está reservada para otro rol. Si cree que debería tener acceso, pídale a
              un administrador que revise su cuenta.
            </Aviso>
          )}

          {/* Un correo sin confirmar BLOQUEA la asignación de rol, así que es lo
              primero que hay que resolver: sin esto la persona espera un cambio
              que un administrador no puede hacer. */}
          {yo && !yo.correoVerificado && (
            <Aviso tono="alerta" titulo="Su correo no está confirmado">
              Mientras la dirección no esté confirmada, un administrador no puede asignarle rol.{' '}
              <Link to="/verificar-correo" className="text-marca-600 underline hover:no-underline">
                Pedir otro enlace de confirmación
              </Link>
              .
            </Aviso>
          )}
        </div>

        {yo && (
          <dl className="mt-4 text-[12.5px] text-acero-600 space-y-1">
            <div className="flex gap-2">
              <dt className="text-acero-500 w-20">Cuenta</dt>
              <dd className="text-acero-900">{yo.email}</dd>
            </div>
            <div className="flex gap-2">
              <dt className="text-acero-500 w-20">Rol actual</dt>
              <dd className="text-acero-900">{yo.rol}</dd>
            </div>
            {yo.organizacion && (
              <div className="flex gap-2">
                <dt className="text-acero-500 w-20">Organización</dt>
                <dd className="text-acero-900">{yo.organizacion}</dd>
              </div>
            )}
          </dl>
        )}

        {/*
          La salida es hacia donde la persona SÍ puede trabajar. Mandar a un
          proveedor al catálogo desde acá lo haría rebotar contra el mismo
          redirect que lo saca de la vitrina, y quedaría dando vueltas entre dos
          pantallas que no le sirven.
        */}
        <div className="mt-4 flex gap-2">
          {yo?.rol === 'proveedor' ? (
            <Link to="/proveedor" className="btn btn-accion">
              Ir a mis productos
            </Link>
          ) : (
            <Link to="/catalogo" className="btn btn-accion">
              Ir al catálogo
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}
